import React, { PropTypes, Component } from 'react';
import { Link, IndexLink } from 'react-router';

import Hero from './Hero';
import Details from './Details';
import Testimonials from './Testimonials';
import About from './About';
import Conclusion from './Conclusion';

class LandingPage extends Component {
    render () {
        return (
            <div className="content">
              <Hero />
              <Details />
              <About />
              <Conclusion />
            </div>
        );
    }
}

export default LandingPage;



/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/index.js
 **/